import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/** Content of assets/deploy-env as committed: keep the compiled environment, nothing to apply. */
const LOCAL_DEPLOY_ENV = 'local';
/** A deployable environment is one of the CCI configurations: environment.<name>.ts, name ending in CCI. */
const DEPLOY_ENV_PATTERN = /^[A-Za-z]+CCI$/;

/**
 * Applies the environment the container was started for. assets/deploy-env holds a single word,
 * rendered by nginx from DEPLOY_ENV; the committed file says `local`, so npm start and every
 * `ng serve -c` keep their compiled values. The word names the file: environment.<word>.ts is
 * loaded by name, so there is no table to keep in step with the files. A word without a file
 * stops the application rather than letting it run on a guessed environment.
 */
async function applyDeployEnvironment(): Promise<void> {
  const response = await fetch('assets/deploy-env', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`assets/deploy-env: HTTP ${response.status}`);
  }

  const name = (await response.text()).trim();
  if (name === LOCAL_DEPLOY_ENV) {
    return;
  }
  if (!DEPLOY_ENV_PATTERN.test(name)) {
    throw new Error(`DEPLOY_ENV invalide : "${name}"`);
  }

  const module = await import(`./environments/environment.${name}`);
  Object.assign(environment, module.environment);
}

if (environment.production) {
  enableProdMode();
}

applyDeployEnvironment()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
